import { onDocumentReady } from "@story/story_assets/utils";

export function FilterModal(element) {
	this.element = element;
	this.backdrop = element.querySelector('.filter-modal-backdrop');
	this.closeBtn = element.querySelector('[data-filter-modal-close]');

	this.bindEvents();
}

FilterModal.prototype = {
	constructor: FilterModal,

	bindEvents: function() {
		if (this.backdrop) {
			this.backdrop.addEventListener('click', this.close.bind(this));
		}

		if (this.closeBtn) {
			this.closeBtn.addEventListener('click', this.close.bind(this));
		}

		this.onKeyDown = this.handleKeyDown.bind(this);
		document.addEventListener('keydown', this.onKeyDown);
	},

	handleKeyDown: function(e) {
		if (e.key === 'Escape' && this.isOpen()) {
			this.close();
		}
	},

	isOpen: function() {
		return this.element.classList.contains('is-open');
	},

	open: function() {
		this.element.classList.add('is-open');
		document.body.style.overflow = 'hidden';
	},

	close: function() {
		this.element.classList.remove('is-open');
		document.body.style.overflow = '';
	}
};

onDocumentReady(function() {
	var triggers = document.querySelectorAll('[data-filter-modal-open]');

	for (var i = 0; i < triggers.length; i++) {
		var targetId = triggers[i].getAttribute('data-filter-modal-open');
		var modalElement = document.getElementById(targetId);

		if (modalElement) {
			var modal = new FilterModal(modalElement);
			modalElement._filterModal = modal;

			triggers[i].addEventListener('click', (function(m) {
				return function(e) {
					e.preventDefault();
					m.open();
				};
			})(modal));
		}
	}
});
